import { default as certificate3HvJN9JOnhMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/certificate.vue?macro=true";
import { default as collectJv4lSUc4eyMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/collect.vue?macro=true";
import { default as couponWdbBIbxuIVMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/coupon.vue?macro=true";
import { default as coursePLek34Ps2oMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/course.vue?macro=true";
import { default as gradeUgVmfYJxwMMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/grade.vue?macro=true";
import { default as info1LeqcElvlDMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/info.vue?macro=true";
import { default as indexasXb3SZ52vMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/message/index.vue?macro=true";
import { default as moneyJq5ABFnPAKMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/money.vue?macro=true";
import { default as noteYXHaMlgDajMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/note.vue?macro=true";
import { default as indexVX5qvpkxpVMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/order/index.vue?macro=true";
import { default as paperSN8kWUNL7zMeta } from "/home/jcwl/project/roncoo-education-web/pages/account/paper.vue?macro=true";
import { default as listzVwfdabofuMeta } from "/home/jcwl/project/roncoo-education-web/pages/article/list.vue?macro=true";
import { default as viewf2uqOx38AUMeta } from "/home/jcwl/project/roncoo-education-web/pages/article/view.vue?macro=true";
import { default as audioiOo3WYuYjFMeta } from "/home/jcwl/project/roncoo-education-web/pages/course/audio.vue?macro=true";
import { default as combine3NNZpCRmNtMeta } from "/home/jcwl/project/roncoo-education-web/pages/course/combine.vue?macro=true";
import { default as graphicmG2RpVCko4Meta } from "/home/jcwl/project/roncoo-education-web/pages/course/graphic.vue?macro=true";
import { default as listxomKsoku23Meta } from "/home/jcwl/project/roncoo-education-web/pages/course/list.vue?macro=true";
import { default as liveeLZLiMToWHMeta } from "/home/jcwl/project/roncoo-education-web/pages/course/live.vue?macro=true";
import { default as singlewYpKwrCywvMeta } from "/home/jcwl/project/roncoo-education-web/pages/course/single.vue?macro=true";
import { default as subjectjvw8uNaNm5Meta } from "/home/jcwl/project/roncoo-education-web/pages/course/subject.vue?macro=true";
import { default as subject_copy15tOAot5dt8Meta } from "/home/jcwl/project/roncoo-education-web/pages/course/subject_copy1.vue?macro=true";
import { default as topicEOCs15bWwCMeta } from "/home/jcwl/project/roncoo-education-web/pages/course/topic.vue?macro=true";
import { default as videoOxhQ968iLiMeta } from "/home/jcwl/project/roncoo-education-web/pages/course/video.vue?macro=true";
import { default as analysisSMWeKA84QsMeta } from "/home/jcwl/project/roncoo-education-web/pages/exam/analysis.vue?macro=true";
import { default as emigratedC3HEQYHbNuMeta } from "/home/jcwl/project/roncoo-education-web/pages/exam/emigrated.vue?macro=true";
import { default as indexQhK4JCOIukMeta } from "/home/jcwl/project/roncoo-education-web/pages/exam/index.vue?macro=true";
import { default as list3rdS8CWknsMeta } from "/home/jcwl/project/roncoo-education-web/pages/exam/list.vue?macro=true";
import { default as resultrXDcjybndVMeta } from "/home/jcwl/project/roncoo-education-web/pages/exam/result.vue?macro=true";
import { default as startExam0mLALyNXXSMeta } from "/home/jcwl/project/roncoo-education-web/pages/exam/startExam.vue?macro=true";
import { default as homeworkJVTS4FunIJMeta } from "/home/jcwl/project/roncoo-education-web/pages/grade/homework.vue?macro=true";
import { default as listjrIhlVWWbEMeta } from "/home/jcwl/project/roncoo-education-web/pages/grade/list.vue?macro=true";
import { default as practice2KWsMSUwHgMeta } from "/home/jcwl/project/roncoo-education-web/pages/grade/practice.vue?macro=true";
import { default as view6LJ2tFhmbFMeta } from "/home/jcwl/project/roncoo-education-web/pages/grade/view.vue?macro=true";
import { default as index5hUdYD1P5cMeta } from "/home/jcwl/project/roncoo-education-web/pages/index.vue?macro=true";
import { default as agreementO6GzmF3tgAMeta } from "/home/jcwl/project/roncoo-education-web/pages/login/agreement.vue?macro=true";
import { default as indexgeBNjlNtIGMeta } from "/home/jcwl/project/roncoo-education-web/pages/login/index.vue?macro=true";
import { default as emigratedzJbPh2creAMeta } from "/home/jcwl/project/roncoo-education-web/pages/paper/emigrated.vue?macro=true";
import { default as indexta08isbEoMMeta } from "/home/jcwl/project/roncoo-education-web/pages/paper/index.vue?macro=true";
import { default as listvlQ5N2Ig2SMeta } from "/home/jcwl/project/roncoo-education-web/pages/paper/list.vue?macro=true";
import { default as view5dX58BxgXlMeta } from "/home/jcwl/project/roncoo-education-web/pages/paper/view.vue?macro=true";
import { default as buy0bcZX9ET4rMeta } from "/home/jcwl/project/roncoo-education-web/pages/pay/buy.vue?macro=true";
import { default as paySuccesstKeiJvKHzHMeta } from "/home/jcwl/project/roncoo-education-web/pages/pay/paySuccess.vue?macro=true";
import { default as indexSm4HPdKThcMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/course/index.vue?macro=true";
import { default as courseList53iceyEFAGMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/courseList.vue?macro=true";
import { default as indexT9ROWkZ8HPMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/grade/index.vue?macro=true";
import { default as gradeList3fuecyGB39Meta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/gradeList.vue?macro=true";
import { default as listoVhN1GI7vwMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/list.vue?macro=true";
import { default as indexKaoy3N0UVFMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/paper/index.vue?macro=true";
import { default as paperListZwkcviHV6ZMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/paperList.vue?macro=true";
import { default as vipCarddCJzLFCBBrMeta } from "/home/jcwl/project/roncoo-education-web/pages/popularize/vipCard.vue?macro=true";
import { default as analysisuLYSBzG35fMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/analysis.vue?macro=true";
import { default as dailybdOTp0OBePMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/daily.vue?macro=true";
import { default as dailyProblemGIx0a6PCtIMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/dailyProblem.vue?macro=true";
import { default as errorhhyCUmzRtnMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/error.vue?macro=true";
import { default as errorAnalysisZ24b4oh47aMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/errorAnalysis.vue?macro=true";
import { default as errorProblemD2NCGzKfjNMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/errorProblem.vue?macro=true";
import { default as errorResultYEQIfEAar8Meta } from "/home/jcwl/project/roncoo-education-web/pages/practice/errorResult.vue?macro=true";
import { default as resultO1Gqlisb8DMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/result.vue?macro=true";
import { default as startPractice1uVSFBdJkJMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/startPractice.vue?macro=true";
import { default as viewt5OQlSM0jxMeta } from "/home/jcwl/project/roncoo-education-web/pages/practice/view.vue?macro=true";
import { default as indexQbbMM4XdOAMeta } from "/home/jcwl/project/roncoo-education-web/pages/register/index.vue?macro=true";
import { default as indexM54XjrqBaXMeta } from "/home/jcwl/project/roncoo-education-web/pages/resetpwd/index.vue?macro=true";
import { default as indexchxcOSEz0JMeta } from "/home/jcwl/project/roncoo-education-web/pages/search/index.vue?macro=true";
import { default as listYplIgfGJjnMeta } from "/home/jcwl/project/roncoo-education-web/pages/tch/list.vue?macro=true";
import { default as viewB8B7Y9U2FKMeta } from "/home/jcwl/project/roncoo-education-web/pages/tch/view.vue?macro=true";
import { default as listb3AXgOrxG6Meta } from "/home/jcwl/project/roncoo-education-web/pages/teacher/list.vue?macro=true";
import { default as viewHX8jB1kGj5Meta } from "/home/jcwl/project/roncoo-education-web/pages/teacher/view.vue?macro=true";
import { default as index8W2H7xwRuZMeta } from "/home/jcwl/project/roncoo-education-web/pages/vip/index.vue?macro=true";
import { default as successZcAANPyqJAMeta } from "/home/jcwl/project/roncoo-education-web/pages/wx/success.vue?macro=true";
import { default as wx549nlH0PWZMeta } from "/home/jcwl/project/roncoo-education-web/pages/wx/wx.vue?macro=true";
export default [
  {
    name: certificate3HvJN9JOnhMeta?.name ?? "account-certificate",
    path: certificate3HvJN9JOnhMeta?.path ?? "/account/certificate",
    meta: certificate3HvJN9JOnhMeta || {},
    alias: certificate3HvJN9JOnhMeta?.alias || [],
    redirect: certificate3HvJN9JOnhMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/certificate.vue").then(m => m.default || m)
  },
  {
    name: collectJv4lSUc4eyMeta?.name ?? "account-collect",
    path: collectJv4lSUc4eyMeta?.path ?? "/account/collect",
    meta: collectJv4lSUc4eyMeta || {},
    alias: collectJv4lSUc4eyMeta?.alias || [],
    redirect: collectJv4lSUc4eyMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/collect.vue").then(m => m.default || m)
  },
  {
    name: couponWdbBIbxuIVMeta?.name ?? "account-coupon",
    path: couponWdbBIbxuIVMeta?.path ?? "/account/coupon",
    meta: couponWdbBIbxuIVMeta || {},
    alias: couponWdbBIbxuIVMeta?.alias || [],
    redirect: couponWdbBIbxuIVMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/coupon.vue").then(m => m.default || m)
  },
  {
    name: coursePLek34Ps2oMeta?.name ?? "account-course",
    path: coursePLek34Ps2oMeta?.path ?? "/account/course",
    meta: coursePLek34Ps2oMeta || {},
    alias: coursePLek34Ps2oMeta?.alias || [],
    redirect: coursePLek34Ps2oMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/course.vue").then(m => m.default || m)
  },
  {
    name: gradeUgVmfYJxwMMeta?.name ?? "account-grade",
    path: gradeUgVmfYJxwMMeta?.path ?? "/account/grade",
    meta: gradeUgVmfYJxwMMeta || {},
    alias: gradeUgVmfYJxwMMeta?.alias || [],
    redirect: gradeUgVmfYJxwMMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/grade.vue").then(m => m.default || m)
  },
  {
    name: info1LeqcElvlDMeta?.name ?? "account-info",
    path: info1LeqcElvlDMeta?.path ?? "/account/info",
    meta: info1LeqcElvlDMeta || {},
    alias: info1LeqcElvlDMeta?.alias || [],
    redirect: info1LeqcElvlDMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/info.vue").then(m => m.default || m)
  },
  {
    name: indexasXb3SZ52vMeta?.name ?? "account-message",
    path: indexasXb3SZ52vMeta?.path ?? "/account/message",
    meta: indexasXb3SZ52vMeta || {},
    alias: indexasXb3SZ52vMeta?.alias || [],
    redirect: indexasXb3SZ52vMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/message/index.vue").then(m => m.default || m)
  },
  {
    name: moneyJq5ABFnPAKMeta?.name ?? "account-money",
    path: moneyJq5ABFnPAKMeta?.path ?? "/account/money",
    meta: moneyJq5ABFnPAKMeta || {},
    alias: moneyJq5ABFnPAKMeta?.alias || [],
    redirect: moneyJq5ABFnPAKMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/money.vue").then(m => m.default || m)
  },
  {
    name: noteYXHaMlgDajMeta?.name ?? "account-note",
    path: noteYXHaMlgDajMeta?.path ?? "/account/note",
    meta: noteYXHaMlgDajMeta || {},
    alias: noteYXHaMlgDajMeta?.alias || [],
    redirect: noteYXHaMlgDajMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/note.vue").then(m => m.default || m)
  },
  {
    name: indexVX5qvpkxpVMeta?.name ?? "account-order",
    path: indexVX5qvpkxpVMeta?.path ?? "/account/order",
    meta: indexVX5qvpkxpVMeta || {},
    alias: indexVX5qvpkxpVMeta?.alias || [],
    redirect: indexVX5qvpkxpVMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/order/index.vue").then(m => m.default || m)
  },
  {
    name: paperSN8kWUNL7zMeta?.name ?? "account-paper",
    path: paperSN8kWUNL7zMeta?.path ?? "/account/paper",
    meta: paperSN8kWUNL7zMeta || {},
    alias: paperSN8kWUNL7zMeta?.alias || [],
    redirect: paperSN8kWUNL7zMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/account/paper.vue").then(m => m.default || m)
  },
  {
    name: listzVwfdabofuMeta?.name ?? "article-list",
    path: listzVwfdabofuMeta?.path ?? "/article/list",
    meta: listzVwfdabofuMeta || {},
    alias: listzVwfdabofuMeta?.alias || [],
    redirect: listzVwfdabofuMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/article/list.vue").then(m => m.default || m)
  },
  {
    name: viewf2uqOx38AUMeta?.name ?? "article-view",
    path: viewf2uqOx38AUMeta?.path ?? "/article/view",
    meta: viewf2uqOx38AUMeta || {},
    alias: viewf2uqOx38AUMeta?.alias || [],
    redirect: viewf2uqOx38AUMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/article/view.vue").then(m => m.default || m)
  },
  {
    name: audioiOo3WYuYjFMeta?.name ?? "course-audio",
    path: audioiOo3WYuYjFMeta?.path ?? "/course/audio",
    meta: audioiOo3WYuYjFMeta || {},
    alias: audioiOo3WYuYjFMeta?.alias || [],
    redirect: audioiOo3WYuYjFMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/audio.vue").then(m => m.default || m)
  },
  {
    name: combine3NNZpCRmNtMeta?.name ?? "course-combine",
    path: combine3NNZpCRmNtMeta?.path ?? "/course/combine",
    meta: combine3NNZpCRmNtMeta || {},
    alias: combine3NNZpCRmNtMeta?.alias || [],
    redirect: combine3NNZpCRmNtMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/combine.vue").then(m => m.default || m)
  },
  {
    name: graphicmG2RpVCko4Meta?.name ?? "course-graphic",
    path: graphicmG2RpVCko4Meta?.path ?? "/course/graphic",
    meta: graphicmG2RpVCko4Meta || {},
    alias: graphicmG2RpVCko4Meta?.alias || [],
    redirect: graphicmG2RpVCko4Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/graphic.vue").then(m => m.default || m)
  },
  {
    name: listxomKsoku23Meta?.name ?? "course-list",
    path: listxomKsoku23Meta?.path ?? "/course/list",
    meta: listxomKsoku23Meta || {},
    alias: listxomKsoku23Meta?.alias || [],
    redirect: listxomKsoku23Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/list.vue").then(m => m.default || m)
  },
  {
    name: liveeLZLiMToWHMeta?.name ?? "course-live",
    path: liveeLZLiMToWHMeta?.path ?? "/course/live",
    meta: liveeLZLiMToWHMeta || {},
    alias: liveeLZLiMToWHMeta?.alias || [],
    redirect: liveeLZLiMToWHMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/live.vue").then(m => m.default || m)
  },
  {
    name: singlewYpKwrCywvMeta?.name ?? "course-single",
    path: singlewYpKwrCywvMeta?.path ?? "/course/single",
    meta: singlewYpKwrCywvMeta || {},
    alias: singlewYpKwrCywvMeta?.alias || [],
    redirect: singlewYpKwrCywvMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/single.vue").then(m => m.default || m)
  },
  {
    name: subjectjvw8uNaNm5Meta?.name ?? "course-subject",
    path: subjectjvw8uNaNm5Meta?.path ?? "/course/subject",
    meta: subjectjvw8uNaNm5Meta || {},
    alias: subjectjvw8uNaNm5Meta?.alias || [],
    redirect: subjectjvw8uNaNm5Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/subject.vue").then(m => m.default || m)
  },
  {
    name: subject_copy15tOAot5dt8Meta?.name ?? "course-subject_copy1",
    path: subject_copy15tOAot5dt8Meta?.path ?? "/course/subject_copy1",
    meta: subject_copy15tOAot5dt8Meta || {},
    alias: subject_copy15tOAot5dt8Meta?.alias || [],
    redirect: subject_copy15tOAot5dt8Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/subject_copy1.vue").then(m => m.default || m)
  },
  {
    name: topicEOCs15bWwCMeta?.name ?? "course-topic",
    path: topicEOCs15bWwCMeta?.path ?? "/course/topic",
    meta: topicEOCs15bWwCMeta || {},
    alias: topicEOCs15bWwCMeta?.alias || [],
    redirect: topicEOCs15bWwCMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/topic.vue").then(m => m.default || m)
  },
  {
    name: videoOxhQ968iLiMeta?.name ?? "course-video",
    path: videoOxhQ968iLiMeta?.path ?? "/course/video",
    meta: videoOxhQ968iLiMeta || {},
    alias: videoOxhQ968iLiMeta?.alias || [],
    redirect: videoOxhQ968iLiMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/course/video.vue").then(m => m.default || m)
  },
  {
    name: analysisSMWeKA84QsMeta?.name ?? "exam-analysis",
    path: analysisSMWeKA84QsMeta?.path ?? "/exam/analysis",
    meta: analysisSMWeKA84QsMeta || {},
    alias: analysisSMWeKA84QsMeta?.alias || [],
    redirect: analysisSMWeKA84QsMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/exam/analysis.vue").then(m => m.default || m)
  },
  {
    name: emigratedC3HEQYHbNuMeta?.name ?? "exam-emigrated",
    path: emigratedC3HEQYHbNuMeta?.path ?? "/exam/emigrated",
    meta: emigratedC3HEQYHbNuMeta || {},
    alias: emigratedC3HEQYHbNuMeta?.alias || [],
    redirect: emigratedC3HEQYHbNuMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/exam/emigrated.vue").then(m => m.default || m)
  },
  {
    name: indexQhK4JCOIukMeta?.name ?? "exam",
    path: indexQhK4JCOIukMeta?.path ?? "/exam",
    meta: indexQhK4JCOIukMeta || {},
    alias: indexQhK4JCOIukMeta?.alias || [],
    redirect: indexQhK4JCOIukMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/exam/index.vue").then(m => m.default || m)
  },
  {
    name: list3rdS8CWknsMeta?.name ?? "exam-list",
    path: list3rdS8CWknsMeta?.path ?? "/exam/list",
    meta: list3rdS8CWknsMeta || {},
    alias: list3rdS8CWknsMeta?.alias || [],
    redirect: list3rdS8CWknsMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/exam/list.vue").then(m => m.default || m)
  },
  {
    name: resultrXDcjybndVMeta?.name ?? "exam-result",
    path: resultrXDcjybndVMeta?.path ?? "/exam/result",
    meta: resultrXDcjybndVMeta || {},
    alias: resultrXDcjybndVMeta?.alias || [],
    redirect: resultrXDcjybndVMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/exam/result.vue").then(m => m.default || m)
  },
  {
    name: startExam0mLALyNXXSMeta?.name ?? "exam-startExam",
    path: startExam0mLALyNXXSMeta?.path ?? "/exam/startExam",
    meta: startExam0mLALyNXXSMeta || {},
    alias: startExam0mLALyNXXSMeta?.alias || [],
    redirect: startExam0mLALyNXXSMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/exam/startExam.vue").then(m => m.default || m)
  },
  {
    name: homeworkJVTS4FunIJMeta?.name ?? "grade-homework",
    path: homeworkJVTS4FunIJMeta?.path ?? "/grade/homework",
    meta: homeworkJVTS4FunIJMeta || {},
    alias: homeworkJVTS4FunIJMeta?.alias || [],
    redirect: homeworkJVTS4FunIJMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/grade/homework.vue").then(m => m.default || m)
  },
  {
    name: listjrIhlVWWbEMeta?.name ?? "grade-list",
    path: listjrIhlVWWbEMeta?.path ?? "/grade/list",
    meta: listjrIhlVWWbEMeta || {},
    alias: listjrIhlVWWbEMeta?.alias || [],
    redirect: listjrIhlVWWbEMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/grade/list.vue").then(m => m.default || m)
  },
  {
    name: practice2KWsMSUwHgMeta?.name ?? "grade-practice",
    path: practice2KWsMSUwHgMeta?.path ?? "/grade/practice",
    meta: practice2KWsMSUwHgMeta || {},
    alias: practice2KWsMSUwHgMeta?.alias || [],
    redirect: practice2KWsMSUwHgMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/grade/practice.vue").then(m => m.default || m)
  },
  {
    name: view6LJ2tFhmbFMeta?.name ?? "grade-view",
    path: view6LJ2tFhmbFMeta?.path ?? "/grade/view",
    meta: view6LJ2tFhmbFMeta || {},
    alias: view6LJ2tFhmbFMeta?.alias || [],
    redirect: view6LJ2tFhmbFMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/grade/view.vue").then(m => m.default || m)
  },
  {
    name: index5hUdYD1P5cMeta?.name ?? "index",
    path: index5hUdYD1P5cMeta?.path ?? "/",
    meta: index5hUdYD1P5cMeta || {},
    alias: index5hUdYD1P5cMeta?.alias || [],
    redirect: index5hUdYD1P5cMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: agreementO6GzmF3tgAMeta?.name ?? "login-agreement",
    path: agreementO6GzmF3tgAMeta?.path ?? "/login/agreement",
    meta: agreementO6GzmF3tgAMeta || {},
    alias: agreementO6GzmF3tgAMeta?.alias || [],
    redirect: agreementO6GzmF3tgAMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/login/agreement.vue").then(m => m.default || m)
  },
  {
    name: indexgeBNjlNtIGMeta?.name ?? "login",
    path: indexgeBNjlNtIGMeta?.path ?? "/login",
    meta: indexgeBNjlNtIGMeta || {},
    alias: indexgeBNjlNtIGMeta?.alias || [],
    redirect: indexgeBNjlNtIGMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: emigratedzJbPh2creAMeta?.name ?? "paper-emigrated",
    path: emigratedzJbPh2creAMeta?.path ?? "/paper/emigrated",
    meta: emigratedzJbPh2creAMeta || {},
    alias: emigratedzJbPh2creAMeta?.alias || [],
    redirect: emigratedzJbPh2creAMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/paper/emigrated.vue").then(m => m.default || m)
  },
  {
    name: indexta08isbEoMMeta?.name ?? "paper",
    path: indexta08isbEoMMeta?.path ?? "/paper",
    meta: indexta08isbEoMMeta || {},
    alias: indexta08isbEoMMeta?.alias || [],
    redirect: indexta08isbEoMMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/paper/index.vue").then(m => m.default || m)
  },
  {
    name: listvlQ5N2Ig2SMeta?.name ?? "paper-list",
    path: listvlQ5N2Ig2SMeta?.path ?? "/paper/list",
    meta: listvlQ5N2Ig2SMeta || {},
    alias: listvlQ5N2Ig2SMeta?.alias || [],
    redirect: listvlQ5N2Ig2SMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/paper/list.vue").then(m => m.default || m)
  },
  {
    name: view5dX58BxgXlMeta?.name ?? "paper-view",
    path: view5dX58BxgXlMeta?.path ?? "/paper/view",
    meta: view5dX58BxgXlMeta || {},
    alias: view5dX58BxgXlMeta?.alias || [],
    redirect: view5dX58BxgXlMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/paper/view.vue").then(m => m.default || m)
  },
  {
    name: buy0bcZX9ET4rMeta?.name ?? "pay-buy",
    path: buy0bcZX9ET4rMeta?.path ?? "/pay/buy",
    meta: buy0bcZX9ET4rMeta || {},
    alias: buy0bcZX9ET4rMeta?.alias || [],
    redirect: buy0bcZX9ET4rMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/pay/buy.vue").then(m => m.default || m)
  },
  {
    name: paySuccesstKeiJvKHzHMeta?.name ?? "pay-paySuccess",
    path: paySuccesstKeiJvKHzHMeta?.path ?? "/pay/paySuccess",
    meta: paySuccesstKeiJvKHzHMeta || {},
    alias: paySuccesstKeiJvKHzHMeta?.alias || [],
    redirect: paySuccesstKeiJvKHzHMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/pay/paySuccess.vue").then(m => m.default || m)
  },
  {
    name: indexSm4HPdKThcMeta?.name ?? "popularize-course",
    path: indexSm4HPdKThcMeta?.path ?? "/popularize/course",
    meta: indexSm4HPdKThcMeta || {},
    alias: indexSm4HPdKThcMeta?.alias || [],
    redirect: indexSm4HPdKThcMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/course/index.vue").then(m => m.default || m)
  },
  {
    name: courseList53iceyEFAGMeta?.name ?? "popularize-courseList",
    path: courseList53iceyEFAGMeta?.path ?? "/popularize/courseList",
    meta: courseList53iceyEFAGMeta || {},
    alias: courseList53iceyEFAGMeta?.alias || [],
    redirect: courseList53iceyEFAGMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/courseList.vue").then(m => m.default || m)
  },
  {
    name: indexT9ROWkZ8HPMeta?.name ?? "popularize-grade",
    path: indexT9ROWkZ8HPMeta?.path ?? "/popularize/grade",
    meta: indexT9ROWkZ8HPMeta || {},
    alias: indexT9ROWkZ8HPMeta?.alias || [],
    redirect: indexT9ROWkZ8HPMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/grade/index.vue").then(m => m.default || m)
  },
  {
    name: gradeList3fuecyGB39Meta?.name ?? "popularize-gradeList",
    path: gradeList3fuecyGB39Meta?.path ?? "/popularize/gradeList",
    meta: gradeList3fuecyGB39Meta || {},
    alias: gradeList3fuecyGB39Meta?.alias || [],
    redirect: gradeList3fuecyGB39Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/gradeList.vue").then(m => m.default || m)
  },
  {
    name: listoVhN1GI7vwMeta?.name ?? "popularize-list",
    path: listoVhN1GI7vwMeta?.path ?? "/popularize/list",
    meta: listoVhN1GI7vwMeta || {},
    alias: listoVhN1GI7vwMeta?.alias || [],
    redirect: listoVhN1GI7vwMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/list.vue").then(m => m.default || m)
  },
  {
    name: indexKaoy3N0UVFMeta?.name ?? "popularize-paper",
    path: indexKaoy3N0UVFMeta?.path ?? "/popularize/paper",
    meta: indexKaoy3N0UVFMeta || {},
    alias: indexKaoy3N0UVFMeta?.alias || [],
    redirect: indexKaoy3N0UVFMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/paper/index.vue").then(m => m.default || m)
  },
  {
    name: paperListZwkcviHV6ZMeta?.name ?? "popularize-paperList",
    path: paperListZwkcviHV6ZMeta?.path ?? "/popularize/paperList",
    meta: paperListZwkcviHV6ZMeta || {},
    alias: paperListZwkcviHV6ZMeta?.alias || [],
    redirect: paperListZwkcviHV6ZMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/paperList.vue").then(m => m.default || m)
  },
  {
    name: vipCarddCJzLFCBBrMeta?.name ?? "popularize-vipCard",
    path: vipCarddCJzLFCBBrMeta?.path ?? "/popularize/vipCard",
    meta: vipCarddCJzLFCBBrMeta || {},
    alias: vipCarddCJzLFCBBrMeta?.alias || [],
    redirect: vipCarddCJzLFCBBrMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/popularize/vipCard.vue").then(m => m.default || m)
  },
  {
    name: analysisuLYSBzG35fMeta?.name ?? "practice-analysis",
    path: analysisuLYSBzG35fMeta?.path ?? "/practice/analysis",
    meta: analysisuLYSBzG35fMeta || {},
    alias: analysisuLYSBzG35fMeta?.alias || [],
    redirect: analysisuLYSBzG35fMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/analysis.vue").then(m => m.default || m)
  },
  {
    name: dailybdOTp0OBePMeta?.name ?? "practice-daily",
    path: dailybdOTp0OBePMeta?.path ?? "/practice/daily",
    meta: dailybdOTp0OBePMeta || {},
    alias: dailybdOTp0OBePMeta?.alias || [],
    redirect: dailybdOTp0OBePMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/daily.vue").then(m => m.default || m)
  },
  {
    name: dailyProblemGIx0a6PCtIMeta?.name ?? "practice-dailyProblem",
    path: dailyProblemGIx0a6PCtIMeta?.path ?? "/practice/dailyProblem",
    meta: dailyProblemGIx0a6PCtIMeta || {},
    alias: dailyProblemGIx0a6PCtIMeta?.alias || [],
    redirect: dailyProblemGIx0a6PCtIMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/dailyProblem.vue").then(m => m.default || m)
  },
  {
    name: errorhhyCUmzRtnMeta?.name ?? "practice-error",
    path: errorhhyCUmzRtnMeta?.path ?? "/practice/error",
    meta: errorhhyCUmzRtnMeta || {},
    alias: errorhhyCUmzRtnMeta?.alias || [],
    redirect: errorhhyCUmzRtnMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/error.vue").then(m => m.default || m)
  },
  {
    name: errorAnalysisZ24b4oh47aMeta?.name ?? "practice-errorAnalysis",
    path: errorAnalysisZ24b4oh47aMeta?.path ?? "/practice/errorAnalysis",
    meta: errorAnalysisZ24b4oh47aMeta || {},
    alias: errorAnalysisZ24b4oh47aMeta?.alias || [],
    redirect: errorAnalysisZ24b4oh47aMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/errorAnalysis.vue").then(m => m.default || m)
  },
  {
    name: errorProblemD2NCGzKfjNMeta?.name ?? "practice-errorProblem",
    path: errorProblemD2NCGzKfjNMeta?.path ?? "/practice/errorProblem",
    meta: errorProblemD2NCGzKfjNMeta || {},
    alias: errorProblemD2NCGzKfjNMeta?.alias || [],
    redirect: errorProblemD2NCGzKfjNMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/errorProblem.vue").then(m => m.default || m)
  },
  {
    name: errorResultYEQIfEAar8Meta?.name ?? "practice-errorResult",
    path: errorResultYEQIfEAar8Meta?.path ?? "/practice/errorResult",
    meta: errorResultYEQIfEAar8Meta || {},
    alias: errorResultYEQIfEAar8Meta?.alias || [],
    redirect: errorResultYEQIfEAar8Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/errorResult.vue").then(m => m.default || m)
  },
  {
    name: resultO1Gqlisb8DMeta?.name ?? "practice-result",
    path: resultO1Gqlisb8DMeta?.path ?? "/practice/result",
    meta: resultO1Gqlisb8DMeta || {},
    alias: resultO1Gqlisb8DMeta?.alias || [],
    redirect: resultO1Gqlisb8DMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/result.vue").then(m => m.default || m)
  },
  {
    name: startPractice1uVSFBdJkJMeta?.name ?? "practice-startPractice",
    path: startPractice1uVSFBdJkJMeta?.path ?? "/practice/startPractice",
    meta: startPractice1uVSFBdJkJMeta || {},
    alias: startPractice1uVSFBdJkJMeta?.alias || [],
    redirect: startPractice1uVSFBdJkJMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/startPractice.vue").then(m => m.default || m)
  },
  {
    name: viewt5OQlSM0jxMeta?.name ?? "practice-view",
    path: viewt5OQlSM0jxMeta?.path ?? "/practice/view",
    meta: viewt5OQlSM0jxMeta || {},
    alias: viewt5OQlSM0jxMeta?.alias || [],
    redirect: viewt5OQlSM0jxMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/practice/view.vue").then(m => m.default || m)
  },
  {
    name: indexQbbMM4XdOAMeta?.name ?? "register",
    path: indexQbbMM4XdOAMeta?.path ?? "/register",
    meta: indexQbbMM4XdOAMeta || {},
    alias: indexQbbMM4XdOAMeta?.alias || [],
    redirect: indexQbbMM4XdOAMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/register/index.vue").then(m => m.default || m)
  },
  {
    name: indexM54XjrqBaXMeta?.name ?? "resetpwd",
    path: indexM54XjrqBaXMeta?.path ?? "/resetpwd",
    meta: indexM54XjrqBaXMeta || {},
    alias: indexM54XjrqBaXMeta?.alias || [],
    redirect: indexM54XjrqBaXMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/resetpwd/index.vue").then(m => m.default || m)
  },
  {
    name: indexchxcOSEz0JMeta?.name ?? "search",
    path: indexchxcOSEz0JMeta?.path ?? "/search",
    meta: indexchxcOSEz0JMeta || {},
    alias: indexchxcOSEz0JMeta?.alias || [],
    redirect: indexchxcOSEz0JMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: listYplIgfGJjnMeta?.name ?? "tch-list",
    path: listYplIgfGJjnMeta?.path ?? "/tch/list",
    meta: listYplIgfGJjnMeta || {},
    alias: listYplIgfGJjnMeta?.alias || [],
    redirect: listYplIgfGJjnMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/tch/list.vue").then(m => m.default || m)
  },
  {
    name: viewB8B7Y9U2FKMeta?.name ?? "tch-view",
    path: viewB8B7Y9U2FKMeta?.path ?? "/tch/view",
    meta: viewB8B7Y9U2FKMeta || {},
    alias: viewB8B7Y9U2FKMeta?.alias || [],
    redirect: viewB8B7Y9U2FKMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/tch/view.vue").then(m => m.default || m)
  },
  {
    name: listb3AXgOrxG6Meta?.name ?? "teacher-list",
    path: listb3AXgOrxG6Meta?.path ?? "/teacher/list",
    meta: listb3AXgOrxG6Meta || {},
    alias: listb3AXgOrxG6Meta?.alias || [],
    redirect: listb3AXgOrxG6Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/teacher/list.vue").then(m => m.default || m)
  },
  {
    name: viewHX8jB1kGj5Meta?.name ?? "teacher-view",
    path: viewHX8jB1kGj5Meta?.path ?? "/teacher/view",
    meta: viewHX8jB1kGj5Meta || {},
    alias: viewHX8jB1kGj5Meta?.alias || [],
    redirect: viewHX8jB1kGj5Meta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/teacher/view.vue").then(m => m.default || m)
  },
  {
    name: index8W2H7xwRuZMeta?.name ?? "vip",
    path: index8W2H7xwRuZMeta?.path ?? "/vip",
    meta: index8W2H7xwRuZMeta || {},
    alias: index8W2H7xwRuZMeta?.alias || [],
    redirect: index8W2H7xwRuZMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/vip/index.vue").then(m => m.default || m)
  },
  {
    name: successZcAANPyqJAMeta?.name ?? "wx-success",
    path: successZcAANPyqJAMeta?.path ?? "/wx/success",
    meta: successZcAANPyqJAMeta || {},
    alias: successZcAANPyqJAMeta?.alias || [],
    redirect: successZcAANPyqJAMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/wx/success.vue").then(m => m.default || m)
  },
  {
    name: wx549nlH0PWZMeta?.name ?? "wx-wx",
    path: wx549nlH0PWZMeta?.path ?? "/wx/wx",
    meta: wx549nlH0PWZMeta || {},
    alias: wx549nlH0PWZMeta?.alias || [],
    redirect: wx549nlH0PWZMeta?.redirect || undefined,
    component: () => import("/home/jcwl/project/roncoo-education-web/pages/wx/wx.vue").then(m => m.default || m)
  }
]